module.exports = __webpack_public_path__ + "bfd0b14c5744fca6bc354710f226ca43.pdf";